import { useMemo } from "react";

export const useScenarioData = ({
  currentStrikeData,
  expectedDays,
  expectedMove,
  strikes,
}) => {
  // Prepare scenario table data
  const scenarioTableData = useMemo(() => {
    if (!currentStrikeData) return [];

    const tradingDay =
      currentStrikeData.trading_days.find(
        (td) => td.trading_days_passed === expectedDays
      ) || currentStrikeData.trading_days[0];

    const scenarios = tradingDay.scenarios;
    const entryPrice = tradingDay.theoretical_price_now;

    return Object.entries(scenarios).map(([movePercent, scenario]) => {
      const riskRewardRatio = scenario.price_change / entryPrice;

      return {
        movePercent,
        futureStockPrice: scenario.future_stock_price,
        exitPrice: scenario.theoretical_price_future,
        priceChange: scenario.price_change,
        returnPct: scenario.price_change_pct,
        riskRewardRatio: riskRewardRatio.toFixed(2),
        entryPrice,
        tradingDay: tradingDay.trading_day,
        daysToExpiration: tradingDay.days_to_expiration,
      };
    });
  }, [currentStrikeData, expectedDays]);

  // Prepare chart data
  const chartData = useMemo(() => {
    if (!scenarioTableData.length) return [];
    return scenarioTableData.map((item) => ({
      move: item.movePercent,
      "Return %": item.returnPct,
    }));
  }, [scenarioTableData]);

  // Prepare strike comparison data
  const strikeComparisonData = useMemo(() => {
    if (!strikes.length || !expectedMove) return [];

    return strikes
      .map((strikeData) => {
        const tradingDay =
          strikeData.trading_days.find(
            (td) => td.trading_days_passed === expectedDays
          ) || strikeData.trading_days[0];

        const scenario = tradingDay.scenarios[`${expectedMove}%`];
        if (!scenario) return null;

        const entryPrice = tradingDay.theoretical_price_now;

        return {
          strike: strikeData.strike,
          entryPrice,
          exitPrice: scenario.theoretical_price_future,
          returnPct: scenario.price_change_pct,
          priceChange: scenario.price_change,
        };
      })
      .filter(Boolean);
  }, [strikes, expectedMove, expectedDays]);

  return { scenarioTableData, chartData, strikeComparisonData };
};
